module.exports = __webpack_public_path__ + "media/images/logo_ept-ef570a59.png";